import * as Immutable from 'immutable';
import ImageStore, { IImageStore } from '../_stores/ImageStore';
import { ImageListAction, ImageListActionType } from '../_actions/ImageListActions';

const ImageListReducer = (store:Immutable.OrderedMap<string, IImageStore> = Immutable.OrderedMap<string, IImageStore>(), action: ImageListAction):Immutable.OrderedMap<string, IImageStore> => {
	switch (action.type) {
		case ImageListActionType.ImageListAdd:
			let imageStore = new ImageStore();
			return store.withMutations(store => {
				store.set(action.image.id, imageStore);
				store.setIn([action.image.id, 'id'], action.image.id);
				store.setIn([action.image.id, 'name'], action.image.name);
				store.setIn([action.image.id, 'src'], action.image.src);
				store.setIn([action.image.id, 'fileid'], action.image.fileid);
				store.setIn([action.image.id, 'width'], action.image.width);
				store.setIn([action.image.id, 'height'], action.image.height);
				store.setIn([action.image.id, 'chunked'], action.image.chunked);
			});

		case ImageListActionType.ImageListRemove:
			return store.delete(action.id);
	}

	return store;
}

export default ImageListReducer